import api from './api';

const leadSubmissionsService = {
  // Get comprehensive dashboard analytics
  getDashboardAnalytics: async (params = {}) => {
    const response = await api.get('/lead-submissions/analytics/dashboard', { params });
    return response.data;
  },

  // Get provider performance metrics
  getProviderPerformance: async (params = {}) => {
    const response = await api.get('/lead-submissions/analytics/performance', { params });
    return response.data;
  },

  // Get all lead submissions with advanced filtering
  getSubmissions: async (params = {}) => {
    const response = await api.get('/lead-submissions', { params });
    return response.data;
  },

  // Get OPENED leads for resubmission
  getOpenedLeads: async (params = {}) => {
    const response = await api.get('/lead-submissions/opened-leads', { params });
    return response.data;
  },

  // Resubmit OPENED leads to service provider
  resubmitOpenedLeads: async (submissionIds) => {
    const response = await api.post('/lead-submissions/resubmit-opened', { submission_ids: submissionIds });
    return response.data;
  },

  // Upload Excel report for advanced matching
  uploadExcelReport: async (file, providerId, reportType = 'feedback') => {
    const formData = new FormData();
    formData.append('excel_file', file);
    formData.append('provider_id', providerId);
    formData.append('report_type', reportType);

    const response = await api.post('/lead-submissions/excel-reports/upload', formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  },

  // Generate comprehensive reports
  generateReport: async (params = {}) => {
    const response = await api.get('/lead-submissions/reports/generate', { 
      params,
      responseType: params.format === 'csv' ? 'blob' : 'json'
    });
    return response.data;
  },

  // Get lead flow history for a specific submission
  getSubmissionFlow: async (id) => {
    const response = await api.get(`/lead-submissions/${id}/flow`);
    return response.data;
  },

  // Get service providers (for filters)
  getServiceProviders: async () => {
    const response = await api.get('/service-providers');
    return response.data;
  }
};

export default leadSubmissionsService;